import { getMessages } from './getMessages';
import { synchronizationMessages } from './synchronizationMessages';
import { BLOB_ID } from '../../constants/blobId';
import { TThunkAction } from '../../types/redux/thunk';
import { ERequestSource, TRequestSource } from '../../utils/logging/publicApiDiagnostics';

/**
 * Обновление сообщений текущего чата
 */
export const updateMessages =
  (
    chatId: string,
    isOnlyCheckUpdate?: boolean,
    source: TRequestSource = ERequestSource.Unknown,
  ): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();

    const { openedChats } = state;

    const currentChat = openedChats[chatId];

    if (chatId === BLOB_ID) {
      return;
    }

    if (isOnlyCheckUpdate) {
      dispatch(synchronizationMessages(chatId, isOnlyCheckUpdate, 0, undefined, source));

      return;
    }

    if (currentChat && currentChat.chatMessages.length > 0) {
      dispatch(synchronizationMessages(chatId, undefined, 0, undefined, source));

      return;
    } else {
      dispatch(getMessages(chatId, source));

      return;
    }

    return;
  };
